import React, { useState, useEffect } from "react";
import "../../components/PetCrate/PetCrate.css";
import axios from "axios";

const PetCrate = ({ crateSelObj, selectedCrate_ID, openProfile, setOpenProfile, tokenStorage }) => {
  const baseAPI = process.env.REACT_APP_API_URL;

  const [firstItem, setFirstItem] = useState({
    Crate_Type: "",
    Amount: "",
    Is_Active: "", 
    Lengths: "",
    Width: "",
    Height: "",
  });

  const [error, setError] = useState("");

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GetAllPetCrates?Crate_ID=${crateSelObj}`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          const data = response.data.data[0];
          setFirstItem(data);
         })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, [crateSelObj.Crate_ID, baseAPI]);

  const handleSubmit = async (e) => {
    e.preventDefault();
  
   
    if (
      !firstItem.Crate_Type ||
      !firstItem.Amount ||
      !firstItem.Height ||
      !firstItem.Width ||
      !firstItem.Lengths ||
      firstItem.Is_Active === ""
    ) {
      alert("All fields are required.");
      return;
    } else {
      setError("");
    }
  
    const dataToSubmit = {
      ...firstItem,
      Is_Active: firstItem.Is_Active ? 1 : 0, 
    };
  
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}adminpost/AddOrUpdatePetCrate`,
        dataToSubmit,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
  
      console.log("Data successfully posted:", response.data);
  
      setFirstItem({
        Crate_Type: "",
        Amount: "",
        Is_Active: "", 
        Lengths: "",
        Width: "",
        Height: "",
      });
      tokenStorage();
      setOpenProfile(!openProfile);
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };
  


  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "Amount" || name==="Height" || name==="Width" || name==="Lengths") {
  
      if (value === "" || /^[0-9\b]+$/.test(value)) {
        setFirstItem((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    } else {
      const updatedValue = name === "Is_Active" ? value === "true" : value;
      setFirstItem((prevData) => ({
        ...prevData,
        [name]: updatedValue,
      }));
    }
  };
  


 
  
  // console.log("FirstItem",firstItem)

  return (
    <div className="container-fluid">
      <br />
      <div className="petCrateDetail">
        <form className="petCrate-form" onSubmit={handleSubmit}>
          {error && <p className="error">{error}</p>}
          <table style={{ width: "100%", }}>
            {/* Render table rows as before */}
            {/* Product Name, Price, and Status Fields */}
            <tr className="tableHeading">
              <td>Product Name</td>
              <td>Price</td>
              <td>Status</td>
            </tr>
            <tr>
              <td>
                <input
                  name="Crate_Type"
                  value={firstItem.Crate_Type}
                  placeholder="Enter Please"
                  onChange={handleChange}
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "14px",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    width:"15rem"
                  }}
                />
              </td>
          
              <td style={{ position: "relative" }}>
  <span
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      fontFamily: "'Montserrat', sans-serif",
      fontSize: "14px",
    }}
  >
    ₹
  </span>
  <input
    name="Amount"
    value={firstItem.Amount}
    placeholder="Enter Please*"
    onChange={handleChange}
    style={{
      fontFamily: "'Montserrat', sans-serif",
      fontSize: "14px",
      padding: "10px 10px 10px 25px", 
      border: "1px solid #ccc",
      borderRadius: "5px",
      width: "15rem",
    }}
  />
</td>

              <td>
                <select
                  name="Is_Active"
                  value={firstItem.Is_Active} 
                  onChange={handleChange}
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "14px",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    width:"15rem"
                  }}
                >
             Select Any Option
                  <option value="false">Inactive</option>
                  <option value="true">Active</option>
                </select>
              </td>
            </tr>
            <tr className="tableHeading">
              <td>Height</td>
              <td>Width</td>
              <td>Length</td>
            </tr>


            <tr>
              <td>
                <input
                  name="Height"
                  value={firstItem.Height}
                  placeholder="Please Enter value in Inches*"
                  onChange={handleChange}
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "14px",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    width:"15rem"
                  }}
                />
              </td>
              <td>
              
                <input
                  name="Width"
                  value={firstItem.Width}
                  placeholder="Please Enter value in Inches*"
                  onChange={handleChange}
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "14px",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    width:"15rem"
                  }}
                />
              </td>
              <td>
              <input
                  name="Lengths"
                  value={firstItem.Lengths}
                  placeholder="Please Enter value in Inches*"
                  onChange={handleChange}
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "14px",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    width:"15rem"
                  }}
                />
              </td>
            </tr>







     
          </table>
          <br />
          <hr />
          <div className="reset-addPetCrate-button">




            
            <button
              type="submit"
              onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Apply
            </button>
            <button
              type="button"
              style={{ backgroundColor: "#F15843", color: "white" }}
              onClick={() => {
                setFirstItem({
                  Crate_ID: selectedCrate_ID,
                  Crate_Type: "",
                  Amount: "",
                  Is_Active: true, // Reset to default active state
                  Lengths: "",
                  Width: "",
                  Height: "",
                });
              }}
            >
              Reset
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default PetCrate;


